import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

const envUrl: string | undefined = import.meta.env.VITE_SUPABASE_URL;
const envKey: string | undefined = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!envUrl || !envKey) {
  // Shown in the console only; the login screen still renders and calls fail with a clear error.
  console.warn('SEO HQ: VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY is not set (see app/.env.production).');
}

export const SUPABASE_URL: string = (envUrl || 'http://localhost:54321').replace(/\/+$/, '');
export const SUPABASE_PUBLISHABLE_KEY: string = envKey || 'missing-key';

export type Db = SupabaseClient<Database, 'seo'>;

/**
 * The browser client. Reads schema `seo` under RLS as the signed-in user. Magic-link sign-in
 * lands on /auth/callback, where `detectSessionInUrl` picks the session out of the URL.
 */
export const supabase: Db = createClient<Database, 'seo'>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    db: { schema: 'seo' },
    auth: import.meta.env.VITE_DEMO
      ? // Demo build: a signed-in sample session kept in memory (src/demo); nothing is persisted.
        { persistSession: true, autoRefreshToken: false, detectSessionInUrl: false, storage: (globalThis as { __seohqDemoStorage?: never }).__seohqDemoStorage }
      : { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
  },
);
